import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type { Lente, ScopeFilter } from '@/types';

export type TopTab = 'entregas' | 'iniciativas';
export type BottomTab = 'hitos' | 'compromisos';

interface UIState {
  lente: Lente;
  setLente: (l: Lente) => void;

  // Scope global aplicado al detalle de una facility.
  scope: ScopeFilter;
  setScope: (scope: ScopeFilter) => void;
  clearScope: () => void;

  // Tabs activos en la vista de detalle.
  topTab: TopTab;
  bottomTab: BottomTab;
  setTopTab: (t: TopTab) => void;
  setBottomTab: (t: BottomTab) => void;
}

export const useUIStore = create<UIState>()(
  persist(
    (set) => ({
      lente: 'interno',
      setLente: (lente) => set({ lente }),
      scope: { type: null, id: null },
      setScope: (scope) => set({ scope }),
      clearScope: () => set({ scope: { type: null, id: null } }),
      topTab: 'entregas',
      bottomTab: 'hitos',
      setTopTab: (topTab) => set({ topTab }),
      setBottomTab: (bottomTab) => set({ bottomTab }),
    }),
    {
      name: 'ui',
      // No persistimos el scope para que al recargar parta limpio
      partialize: (s) => ({
        lente: s.lente,
        topTab: s.topTab,
        bottomTab: s.bottomTab,
      }),
    },
  ),
);
